export const PANEL_IDS = {
  ribbon: "ribbon",
  viewport: "viewport",
  generator: "generator",
  reference: "reference",
  planes: "planes",
  bom: "bom",
  jacks: "jacks",
} as const;

export type PanelId = (typeof PANEL_IDS)[keyof typeof PANEL_IDS];
